import React from 'react';

const SPECIAL_RE = /[!@#$%^&*()\-_=+\[\]{};:'",.<>?/\\|`~]/;

export function validatePassword(password) {
  if (!password || password.length < 8) return 'Das Passwort muss mindestens 8 Zeichen lang sein';
  if (password.length > 12) return 'Das Passwort darf höchstens 12 Zeichen lang sein';
  if (!/[A-Z]/.test(password)) return 'Das Passwort muss mindestens einen Großbuchstaben enthalten';
  if (!/[0-9]/.test(password)) return 'Das Passwort muss mindestens eine Zahl enthalten';
  if (!SPECIAL_RE.test(password)) return 'Das Passwort muss mindestens ein Sonderzeichen enthalten (!@#$%^&* etc.)';
  return null;
}

export function PasswordRequirements({ password = '' }) {
  const rules = [
    { label: '8–12 Zeichen', ok: password.length >= 8 && password.length <= 12 },
    { label: 'Mindestens 1 Großbuchstabe (A–Z)', ok: /[A-Z]/.test(password) },
    { label: 'Mindestens 1 Zahl (0–9)', ok: /[0-9]/.test(password) },
    { label: 'Mindestens 1 Sonderzeichen (!@#$%^&* …)', ok: SPECIAL_RE.test(password) },
  ];
  return (
    <ul className="mt-2 space-y-1">
      {rules.map(r => (
        <li key={r.label} className={`flex items-center gap-1.5 text-xs ${r.ok ? 'text-green-600' : 'text-stone-400'}`}>
          <span className={`inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-[10px] font-bold shrink-0 ${r.ok ? 'bg-green-100' : 'bg-stone-100'}`}>
            {r.ok ? '✓' : '·'}
          </span>
          {r.label}
        </li>
      ))}
    </ul>
  );
}
